export function scenarioStatusReducer(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'scenarioStatus') {
                return action.message.payload;
            }
    }
    return state;
}
export function scenarioReducer(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'scenarioLoad') {
                return action.message.payload;
            }
            break;
    }
    return state;
}
export function tripReducer(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'tripSelection') {
                return action.message.payload;
            }
    }
    return state;
}
export function actualSpeedReducer(speed, action) {
    if (speed === void 0) { speed = 0; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'location') {
                return action.message.payload.speed || 0;
            }
    }
    return speed;
}
export function locationReducer(location, action) {
    if (location === void 0) { location = null; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'location') {
                return action.message.payload;
            }
    }
    return location;
}
export function playingReducer(playing, action) {
    if (playing === void 0) { playing = false; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'play') {
                return action.message.payload;
            }
    }
    return playing;
}
export function scenarioPlayReducer(testCasePlay, action) {
    if (testCasePlay === void 0) { testCasePlay = false; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'scenarioPlay') {
                return action.message.payload;
            }
    }
    return testCasePlay;
}
export function speedReducer(speed, action) {
    if (speed === void 0) { speed = 50; }
    switch (action.type) {
        case 'MAXIMUM_SPEED_CHANGE':
            return action.value;
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'maximumSpeed') {
                return action.message.payload;
            }
    }
    return speed;
}
export function autoStopReducer(state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'autoStop') {
                return action.message.payload;
            }
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/reducers.ts
// module id = 1826
// module chunks = 0